import React, { createContext, useContext, PropsWithChildren } from 'react';

/* Interfaces */
import { AnalyticsClient } from '../Client';
import { AppboyAnalyticsHandler } from '../AppboyAnalyticsHandler';
import { FirebaseAnalyticsHandler } from '../FirebaseAnalyticsHandler';
import { BIEventsAnalyticsHandler } from '../BIEventsAnalyticsHandler';
import { MixpanelAnalyticsHandler } from '../MixpanelAnalyticsHandler';

interface AnalyticsHandlersContent {
  client: AnalyticsClient;
}

export const AnalyticsHandlersContext =
  createContext<AnalyticsHandlersContent | null>(null);

export const AnalyticsHandlersProvider: React.FC<PropsWithChildren> = ({
  children,
}) => {
  const appboy = new AppboyAnalyticsHandler();
  const firebase = new FirebaseAnalyticsHandler();
  const BIEvent = new BIEventsAnalyticsHandler();
  const mixpanel = new MixpanelAnalyticsHandler();

  const value = {
    client: new AnalyticsClient(appboy, firebase, BIEvent, mixpanel),
  };

  return (
    <AnalyticsHandlersContext.Provider value={value}>
      {children}
    </AnalyticsHandlersContext.Provider>
  );
};

export const useAnalyticsHandlers = () => useContext(AnalyticsHandlersContext);
